export enum PlanId {
  FRE = "FRE",
  MAX = "MAX",
  MBI = "MBI",
  MCI = "MCI",
  FLX = "FLX",
  EST = "EST",
  PLN = "PLN",
  USR = "USR",
  SMR = "SMR",
  DEF = "DEF",
}

export interface IJointBillServiceProviderBillPlan {
  jointBillServicePlanId: PlanId;
  price: number;
  discountedPrice: number;
  discountSizePercentage: number;
  discountedMonths: number;
  discountExpirationDate: Date;
  currencyId: string;
  isSelected: boolean;
  isValidForJointBillService: boolean;
}

export interface IJointBillServiceProviderBillPlanRequest {
  jointBillServiceId: number;
}

export interface IUpdateJointBillServiceProviderBillPlanRequest {
  jointBillServiceId: number;
  jointBillServicePlanId: PlanId;
  externalRelateType?: string;
  activeCampaignId?: string;
  contactInformation?: {
    firstName: string;
    lastName: string;
    email: string;
    skipUsernameUpdate: boolean;
    phone: string;
    personalCode: string;
  };
}

export interface ISelectedJointBillServiceProviderBillPlan {
  jointBillServicePlans: {
    jointBillServiceId: number;
    jointBillServiceProviderBillPlanId: PlanId;
    price: number;
  }[];
}
